import React, { useState, useEffect, useRef } from "react";

import * as m from "@/shared/styles/main.module.scss";
import { Arrow } from "@/shared/components/LeftBorder";
import { Question } from "../types/valuebuilder";

interface RadioGroupProps {
  options: Record<string, string> | null;
  label: string;
  groupedQuestionId: number | string;
  groupedQuestionIndex: number;
  parentIndex: number;
  childIndex?: number;
  question: Question;
  setAnswer: (
    e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>
  ) => void;
  isCollapsed?: boolean;
  changeHeight: (height: number, increase: boolean) => void;
}

const RadioGroup: React.FC<RadioGroupProps> = ({
  options: options,
  label,
  groupedQuestionId,
  groupedQuestionIndex,
  parentIndex,
  childIndex,
  question,
  setAnswer,
  isCollapsed,
  changeHeight,
}) => {
  const [isCollapse, setCollapse] = useState(isCollapsed || false);
  const [listHeight, setListHeight] = useState<number | undefined>();
  const ref = useRef<HTMLDivElement>(null);
  useEffect(() => {
    if (ref.current) {
      setListHeight(isCollapse ? 0 : ref.current.scrollHeight);
    }
  }, [isCollapse]);

  const changeCollpase = () => {
    if (ref.current) {
      changeHeight(ref.current.scrollHeight, isCollapse);
      setCollapse(!isCollapse);
    }
  };

  const questionValue = question.value;

  if (typeof questionValue === "string") {
    return null;
  }

  const radioIndex = groupedQuestionIndex + 1;
  return (
    <div className={`${m.formGroup} ${m.subGroup} ${m.radioGroup}`}>
      <div className={m.childIndex}>
        <span>{`${parentIndex}.${
          childIndex ? `${childIndex}.` : ""
        }${radioIndex}`}</span>
      </div>
      <div
        className={`${m.expandOne} ${isCollapse ? m.collapsed : ""}`}
        onClick={changeCollpase}
      >
        <Arrow />
      </div>
      <label className={m.title}>{label}</label>
      <div
        ref={ref}
        className={`${m.radioWrapper} ${
          isCollapse ? m.collapsedRadioWrapper : ""
        }`}
        style={{ height: listHeight }}
      >
        {!options
          ? null
          : Object.keys(options).map((optionValue, i) => {
              const value = parseInt(optionValue);

              return (
                <div
                  key={`${groupedQuestionId}_${value}`}
                  className={m.radioItem}
                >
                  <label
                    className={m.variant}
                    htmlFor={`question_${question.question_id}_${groupedQuestionId}_${value}`}
                  >
                    {options[optionValue]}
                  </label>
                  <label
                    className={m.variant}
                    htmlFor={`question_${question.question_id}_${groupedQuestionId}_${value}`}
                  >
                    —
                  </label>
                  <input
                    type="radio"
                    value={value}
                    checked={
                      questionValue?.[`${groupedQuestionId}`]
                        ? parseInt(questionValue[`${groupedQuestionId}`]) ===
                          value
                        : false
                    }
                    id={`question_${question.question_id}_${groupedQuestionId}_${value}`}
                    data-question-id={question.question_id}
                    data-question-index={`${groupedQuestionId}`}
                    onChange={setAnswer}
                  />
                  <label
                    className={m.mark}
                    htmlFor={`question_${question.question_id}_${groupedQuestionId}_${value}`}
                  ></label>
                </div>
              );
            })}
      </div>
    </div>
  );
};

export default RadioGroup;
